export default "__VITE_ASSET__DcnL9G_r__"